import React from 'react';
import TodoApp from './TodoApp.js';
import './App.css';

function App() {
  return <TodoApp />;
}

export default App;
